module.exports = __webpack_public_path__ + "img/GP3_Austria_Circular Economy Forum Austria.9deea27c.jpg";